import Button from '@/Components/Button';
import Label from '@/Components/Label';
import { OrdersList } from '@/Components/OrdersList';
import RollerLoading from '@/Components/RollerLoading';
import Select from '@/Components/Select';
import Authenticated from '@/Layouts/Authenticated'
import date from '@/helpers/date';
import { Head, useForm } from '@inertiajs/inertia-react';
import axios from 'axios';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import Datetime from 'react-datetime';

const BulkDte = ({ store, auth, errors, allowedMonths, currentYear, allowedYears, lastMonth, lastYear }) => {
    const { data, setData } = useForm({
        start_date: "",
        end_date: "",
    });
    const [isLoading, setIsLoading] = useState(false)
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [orders, setOrders] = useState([])
    const [selectedOrders, setSelectedOrders] = useState([]);

    const [emmitedOrders, setEmmitedOrders] = useState(JSON.parse(localStorage.getItem('emmited-orders') || '[]'));
    const [invoiceRequested, setInvoiceRequested] = useState(false)
    const [ordersListMessage, setOrdersListMessage] = useState('Selecciona mes y año para continuar')

    const handleYearChange = (e) => {
        console.log(e)
        setSelectedYear(e.value);
        setSelectedMonth('')
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        setData(name, value);
    };


    const months = [
        {
            label: 'Enero',
            value: 1
        },
        {
            label: 'Febrero',
            value: 2
        },
        {
            label: 'Marzo',
            value: 3
        },
        {
            label: 'Abril',
            value: 4
        },
        {
            label: 'Mayo',
            value: 5
        },
        {
            label: 'Junio',
            value: 6
        },
        {
            label: 'Julio',
            value: 7
        },
        {
            label: 'Agosto',
            value: 8
        },
        {
            label: 'Septiembre',
            value: 9
        },
        {
            label: 'Octubre',
            value: 10
        },
        {
            label: 'Noviembre',
            value: 11
        },
        {
            label: 'Diciembre',
            value: 12
        },
    ]
    const years = Array.from({ length: currentYear - 2023 + 1 }, (_, index) => 2023 + index);
    const filteredMonths = (year) => {
        if (year === 2023) {
            return months.filter((month) => month.value >= 2);
        }
        return months;
    };

    const fetchOrders = async () => {
        setIsLoading(true)
        try {
            const response = await axios.get(`/get-orders?date=${selectedMonth.value}-${selectedYear}`)
            setOrders(response.data)
            setTimeout(() => {
                setIsLoading(false)
            },2000)
        } catch (error) {
            console.error('Error en axios fetchOrders DTE: ', error)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(orders.length === 0 && selectedMonth && selectedYear) {
            setOrdersListMessage("Las órdenes de este mes están al día o no hay órdenes disponibles.")
        }
    }, [orders])

    const bulkCaptureDTE = async () => {
        if (emmitedOrders.length > 0) return;
        
        try {
            const response = await axios.post(route('bulk-dte.store'), { orders: selectedOrders });
            if (response.data.status === 'success') {
                setEmmitedOrders(selectedOrders)
                localStorage.setItem('emmited-orders', JSON.stringify(selectedOrders));
                setSelectedOrders([])
            }
        } catch (error) {
            console.error("error en bulk CaptureDTE:", error)
            setEmmitedOrders([])
            localStorage.setItem('emmited-orders', JSON.stringify([]));
        }
    }

    const checkBulkCaptureDTE = async () => {
        if (emmitedOrders.length > 0){
            const interval = setInterval(async() => {
                try{
                    const response = await axios.post(`/get-bulk-DTE`, { orders: emmitedOrders})
                    if(response.data.status === 'success'){
                        const checkedOrders = response.data.checked_orders
                        const filteredOrders = emmitedOrders.filter(id => !checkedOrders.includes(id))
                        localStorage.setItem('emmited-orders', JSON.stringify(filteredOrders))
                        setSelectedOrders([])
                        if(filteredOrders.length === 0) {
                            setEmmitedOrders([])
                            clearInterval(interval)
                        }
                    }
                }catch(error){
                    console.error('error en check bulk DTE:', error)
                    setEmmitedOrders([])
                    setSelectedOrders([])
                }
            }, 5000)
        }
    }

    useEffect(() => {
       checkBulkCaptureDTE()
       if(selectedMonth){
           fetchOrders()
       }
    }, [emmitedOrders])

    return (
        <Authenticated
            store={store}
            auth={auth}
            errors={errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Plugin DTE</h2>}
        >
            <Head title="Lista de productos - Cerogrado" />
            <div className="max-w-7xl mx-auto w-full flex justify-between px-4 pt-8 mb-4">
                <div className='lg:w-full md:w-full grid grid-cols-1 sm:grid-cols-2 gap-5 lg:block'>
                    <div className='bg-white shadow-sm sm:rounded-lg border-b border-gray-200 p-3 '>

                        <div className="flex gap-5">
                            <div>

                                <Select
                                    options={allowedYears.map(year => ({ label: year, value: year }))}
                                    id="year-picker"
                                    className="col-span-8 rounded-md shadow-none w-46"
                                    onChange={handleYearChange}
                                    styles={{
                                        indicatorSeparator: () => ({ display: "none" }),
                                        input: (styles) => ({
                                            ...styles,
                                            "> input": {
                                                boxShadow: "none !important",
                                            },
                                        }),
                                    }}
                                    placeholder="Seleccione año"
                                    noOptionsMessage={() =>
                                        "No hay meses para seleccionar"
                                    }
                                />

                            </div>
                            <div>

                                {/* <Label forInput="start_date" value="Seleccione mes:" /> */}
                                <Select
                                    options={filteredMonths(selectedYear).map(month => ({ label: month.label, value: month.value }))}
                                    isClearable
                                    id="start_date"
                                    styles={{
                                        indicatorSeparator: () => ({ display: "none" }),
                                        input: (styles) => ({
                                            ...styles,
                                            "> input": {
                                                boxShadow: "none !important",
                                            },
                                        }),
                                    }}
                                    className="col-span-8 rounded-md shadow-none w-96"
                                    onChange={(newValue) => {
                                        console.log('el value del onchange', newValue)
                                        setSelectedMonth(newValue)
                                    }}
                                    value={selectedMonth}
                                    placeholder="Seleccione un mes"
                                    noOptionsMessage={() =>
                                        "No hay meses para seleccionar"
                                    }

                                />

                            </div>
                            {
                                emmitedOrders.length === 0 &&
                                <Button
                                    onClick={fetchOrders}
                                    processing={!selectedMonth || !selectedYear}
                                //className={`${(!selectedMonth && !selectedYear) ? 'bg-gray-500' : ''}`}
                                >
                                    Buscar
                                </Button>
                            }
                            {/* {
                                selectedOrders.length > 0 &&
                                <button className={classNames("px-4 py-2 bg-primary rounded text-white", {
                                    "opacity-40 cursor-not-allowed": emmitedOrders.length > 0
                                })}
                                    onClick={bulkCaptureDTE}
                                >Emitir Folios seleccionados</button>
                            } */}
                        </div>
                    </div>

                    <div className='bg-white shadow-sm sm:rounded-lg border-b border-gray-200 p-3 mt-5'>
                        {
                            isLoading || (emmitedOrders.length > 0 && selectedMonth && selectedYear) ?
                                <>
                                <div className="flex items-center justify-center flex-col rounded py-10 mx-auto">
                                    <RollerLoading 
                                        scale={`1`}
                                        color="sk-chase-dot-primary"
                                    />

                                    {emmitedOrders.length > 0 && <p className="text-center text-2xl">Emitiendo órdenes</p>}
                                </div>
                                </>
                                :
                                (() => {
                                    if(orders.length > 0 && selectedMonth && selectedYear)
                                    {
                                        return <OrdersList 
                                             emmitedOrders={emmitedOrders} 
                                             isSuperAdmin={true} 
                                             withCheckboxes={true} 
                                             orders={orders} 
                                             selectedOrders={selectedOrders} 
                                             setSelectedOrders={setSelectedOrders}
                                             invoiceRequested={invoiceRequested}
                                             setInvoiceRequested={setInvoiceRequested}
                                        />
                                    }
                                    return <p>{ordersListMessage}</p>
                                })()
                        }
                    </div>
                </div>
            </div>

        </Authenticated>
    )
}

export default BulkDte